export const environment = {
  production: false,
  apiUrl: 'https://services.lendrak.es/comercios',
};
